import {Pipe, PipeTransform} from '@angular/core';
import {Helper} from '../classes';
import {LanguageService} from "../language.service";

@Pipe({
	name: 'productBarrierFrequency',
	pure: false
})
export class ProductBarrierFrequencyPipe implements PipeTransform {
	constructor(private languageService: LanguageService) {
	}

	transform(type: number): string {
		return Helper.textsHelper().getInterestPaymentPeriodName(type, this.languageService);
	}
}
